import React, { useState, useEffect, useMemo } from "react";
import "../Assests/Scss/AddEdit.scss";
import axios from "axios";
import Loading from "../../../Student/Reusablecomponents/Loading";
import TinyMCEDitor from "../../../ReusableComponents/tinymceEditor";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { MainSource, SubMainSource, } from "../../../ReusableComponents/QBDropdowns";
import notify from "../../../ReusableComponents/ToastifyAlerts";
import TranslateEditor from "../MathScienceQuestions/AddQuestions/TranslatEditor";
import QBCList from "../../../ReusableComponents/QBCheckList";
import { DDIssueType } from "../../../ReusableComponents/QBAdmin/CommonDropdowns";
import * as Yup from "yup";
const TranslateScenario = () => {
  const navigate = useNavigate();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector((state) => state.SelectLanguageData.SLanguage);
  const updateScenario = useSelector((state) => state.ScenarioDeatils.ScenarioDetails);

  const [Load, SetLoad] = useState(false);
  const [NTDeatils, SetNTDeatils] = useState(updateScenario?.mainSourceLovId);
  const [NTBased, SetNTBased] = useState(updateScenario?.sSourceId);

  const [GetEditorValue, SetGetEditorValue] = useState(updateScenario?.scenarioHindiName);
  const [OtherComents, SetOtherComents] = useState(updateScenario?.qsOthersComments);
  const [SelceTOS, SetSelceTOS] = useState(updateScenario?.typeOfIssue || "");
  const [AQErrors, SetAQErrors] = useState({});
  const [OpenTranslatEditor, CloseTranslatEditor] = useState(false);
  const [EdiText, SetEdiTest] = useState();
  const EditValues = () => {
    CloseTranslatEditor(!OpenTranslatEditor);
    SetEdiTest({
      value: GetEditorValue,
      Store: SetGetEditorValue,
      AData: "Scenario",
    });
  };
  const UpdateHindiScenario = async () => {
    if (GetEditorValue?.length > 0) {
      SetLoad((prev) => !prev);

      const ScenarioDetails = {
        TypeOfIssue: SelceTOS,
        scenarioID: updateScenario?.scenarioID,
        modifiedBy: items?.userId,
        scenario: GetEditorValue.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
        subjectID: items?.subjectId,
        mainSourceLovId: NTDeatils,
        sSourceId: NTBased,
        otherScenarioComments: OtherComents,
        createdBy: items?.userId,
        scenarioSource: "string",
        addScenarioQuestionChecklist: SCValues
      };
      await axios.post(process.env.REACT_APP_API_BASE_URL + `/Scenario/UpdateHindiScenario`,
        ScenarioDetails, { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
        .then((res) => {
          notify("Scenario updated successfully", "success");
          navigate(-1);
        })
        .catch((err) => { notify("Scenario not updated. Please try again", "error"); });
      SetLoad((prev) => !prev);
    } else {
      notify("Scenario field is required", "warning");
    }
  };
  const [HitCLV, SetHitCLV] = useState(false);
  const [CValidation, SetCValidation] = useState(false);
  const [SCValues, SetSCValues] = useState();
  useEffect(() => {
    if (CValidation) {
      UpdateHindiScenario();
      SetCValidation(false);
    }
  }, [CValidation]);
  const Validation = () => {
    const AllFields = {
      // ...EditorValues,
      SelceTOS,
    };
    validationSchema
      .validate(AllFields, { abortEarly: false })
      .then(() => {
        SetAQErrors({});
        if (CValidation) {
          UpdateHindiScenario();
        }
      })
      .catch((err) => {
        const newErrors = {};
        if (Array.isArray(err.inner)) {
          err.inner.forEach((error) => { newErrors[error.path] = error.message; });
        }
        SetAQErrors(newErrors);
      });
  };
  const validationSchema = Yup.object().shape({
    SelceTOS: Yup.string().required("Type of Issue is required"),
  });

  return (
    <>
      <div className="MainHeading">Update Scenario (in Hindi)</div>
      <div className="Card mt-2">
        <div className="container-fluid">
          <div className="DropdownHeader"> Scenario Source<span>*</span> </div>
          <Row>
            <Col>
              <MainSource className="DisabledNCLDropdown w-100"
                StoreMSource={SetNTDeatils} SOption={NTDeatils}
                LID={SelectLanguage} onChange={(e) => SetNTDeatils(e)} disable={true} />
            </Col>
            <Col>
              <SubMainSource className="DisabledNCLDropdown w-100" StoreSMSource={SetNTBased} SOption={NTBased}
                PId={NTDeatils} LID={SelectLanguage} onChange={(e) => SetNTBased(e)} disable={true} />
              {(NTBased === "3574" || NTBased === "3578") && (
                <input type="text" className=" Search mt-2 p-1 w-100"
                  onChange={(e) => SetOtherComents(e.target.value)} placeholder="Enter Comments" />)}
            </Col>
          </Row>
          <Row>
            <Col><DDIssueType className="NCLDropdown w-100 mb-2" Displayname="Select Type of Issue "
              StoreValue={SetSelceTOS} SOption={SelceTOS} onChange={(e) => SetSelceTOS(e)} />
              {AQErrors?.SelceTOS && (<span className="error-message"> {AQErrors?.SelceTOS} </span>)}</Col>
            <Col></Col>
          </Row>

          <div className="DropdownHeader"> Scenario<span>*</span> </div>
          <Row>
            <Col className="DisabledTiny"> <TinyMCEDitor PostValue={updateScenario?.scenarioName} disable={true} /> </Col>
            <Col> <TinyMCEDitor onChange={(e) => SetGetEditorValue(e)} PostValue={GetEditorValue} Review={true} onClick={() => EditValues()} /> </Col>
          </Row>
          <QBCList Heading="Scenario" HValidation={HitCLV} RStoreHValidation={SetHitCLV} VSuccess={SetCValidation}
            GetValues={SetSCValues} Existinvalues={updateScenario?.status} ExistingId={updateScenario?.checklistQuestionId} LanguageId={SelectLanguage} />
          <div className="ScenarioAU dflex alignitems">
            <button className="Buttons bg-danger" onClick={() => navigate(-1)}> Cancel </button>
            <button className="Buttons bg-success" onClick={() => { Validation(); SetHitCLV(true); }} >
              {updateScenario ? (
                <> Save / Update{" "}
                  <span style={{ fontSize: "8px" }}>(Please go Through The Below Checklist Before Updating The Scenario) </span>  </>
              ) : ("Save")}{" "}
            </button>
          </div>
        </div>
      </div>
      {OpenTranslatEditor && (
        <div className="Model-Open">
          <div className="Card w-100"> <TranslateEditor close={CloseTranslatEditor} EditData={EdiText} /> </div>
        </div>
      )}
      {Load && <Loading />}
    </>
  );
};
export default TranslateScenario;